<div class="d-flex justify-content-between mt-5">
  <div class="me-auto d-sm-block collapse mt-3">
    <div class="fw-bold fst-italic hidden-xxs">
      
      <span *ngIf="pageData.PageSize == total">
        Showing {{pageData.PageNumber * total - total + 1}} - {{(pageData.PageNumber * total)}}
      </span>
      <span *ngIf="pageData.PageSize != total">
        Showing {{(pageData.PageSize * pageData.PageNumber) - pageData.PageSize + 1}} -
        {{(pageData.PageSize * pageData.PageNumber) - pageData.PageSize + total}}
      </span>
      <span class="me-2">of</span>
      <span
        style="cursor: pointer"
        *ngIf="!pageData.HideStoreApiCount"
        (click)="StoreRowsCountAPIResult()"
        ><i class="border p-3">?</i> </span
      ><span *ngIf="pageData.HideStoreApiCount">{{ listTotal | number }}</span>
      records ~
      <span *ngIf="editPageNumber">
        Page
        <input
          class="text-end"
          style="width: 45px"
          type="text"
          autoNum
          (keyup)="onJumpToPage($event)"
          [(ngModel)]="pageNumber"
        />
      </span>
      <span *ngIf="!editPageNumber">
        {{ pageNumber }} Page
      </span>
    </div>
  </div>
  <div class="btn-group">
    <a
      class="btn btn-outline-secondary btn-sm text-primary"
      *ngIf="pageData.PageNumber != 1"
      (click)="onPreviousPage()"
      ><i class="fa-solid fa-arrow-left"></i> Previous</a
    >
    <a
      class="btn btn-outline-secondary btn-sm text-primary"
      *ngIf="total >= pageData.PageSize || nextButtonAlwaysVisible"
      (click)="onNextPage()"
      ><i class="fa-solid fa-arrow-right"></i> Next</a
    >
  </div>
</div>
